export const Stocks = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="16" cy="16" r="16" fill="#8952FF"/>
    <path d="M24.25 11.5L17.125 18.625L13.375 14.875L7.75 20.5" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>

);
